import { styled } from '@classify/react-core-components/styles';

const BulletList = styled('ul')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  margin: 0,
  padding: 0,
});

export default BulletList;
